// extracted by mini-css-extract-plugin
module.exports = {"trading":"index_trading__FytlN","dot":"index_dot__IAPqU"};